import { render } from "./Steps.vue?vue&type=template&id=04cde714&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=04cde714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cde714"]])

export default __exports__